import React, {useEffect, useRef, useState} from "react";
import {InputText}                          from "primereact/inputtext";
import {InputMask}                          from "primereact/inputmask";
import {InputTextarea}                      from "primereact/inputtextarea";
import {Button}                             from "primereact/button";
import {Image}                              from "primereact/image";
import {Toast}                              from "primereact/toast";
import {TabPanel, TabView}                  from "primereact/tabview";
import {DataTable}                          from "primereact/datatable";
import {DataView}                           from "primereact/dataview";
import {confirmDialog}                      from "primereact/confirmdialog";
import {Dropdown}                           from "primereact/dropdown";
import {FilterMatchMode}                    from "primereact/api";
import {Column}                             from "primereact/column";
import {Dialog}                             from "primereact/dialog";
import {Card}                               from "primereact/card";
import uuid                                 from "react-uuid";
import moment                               from "moment";

import {CabecalhoTabela, FundoSistema, Obrigatorio, TelaSistema} from "../../assets/style";
import Menu                                                      from "../../components/menu";
import {Icone}                                                   from "../../components/menu/style";
import api, {URLAPI}                                             from "../../services/api";
import debug                                                     from "../../utils/debug";
import iconeEvento                                               from '../../assets/calendario.png';
import iconeLista                                                from '../../assets/caderno.png';
import iconeParticipantes                                        from '../../assets/falando.png';
import Logo                                                      from "../../assets/LogoLogin.png";
import {UsuarioMaster}                                           from "../../services/auth";
import EnviarImagem                                              from "../../components/enviaImagem";
import {InputSwitch}                                             from "primereact/inputswitch";
import {Fieldset}                                                from "primereact/fieldset";
import {Panel}                                                   from "primereact/panel";
import {RadioButton}                                             from "primereact/radiobutton";

const Evento = () => {
    const aviso = useRef(null);
    const endpointAPI = 'cadastro/evento';
    const fraseEvento = 'Deseja confirmar sua presença no evento';
    const inicial = {
        id      : 0, idcategoria: 0, titulo: '', descricao: '', local: '', endereco: '', hash: uuid(), latitude: 0, longitude: 0, data: null, dia: '', hora: '', imagem: '', responsavel: '', datafim: null, diaf: '', horaf: '',
        telefone: 0, empresa: 0, crm: 0, cargo: 0, especialidade: 0, rg: 0, cpf: 0, nascimento: 0, cep: 0, estado: 0, cidade: 0, enderecop: 0, idcliente: 0, frase: '', tipo: 'E'
    };
    const [item, setItem] = useState(inicial);
    const [loading, setLoading] = useState(true);
    const [lista, setLista] = useState([]);
    const [participantes, setParticipantes] = useState([]);
    const [idEvento, setIdEvento] = useState(0);
    const [exibeTela, setExibirTela] = useState(false);
    const [tabAtiva, setTabAtiva] = useState(0);
    const [listaCategoria, setListaCategoria] = useState([]);
    const [listaClientes, setListaClientes] = useState([]);
    const [pesquisaGeral, setPesquisaGeral] = useState(null);
    const [tituloParticipantes, setTituloParticipantes] = useState('Participantes');
    const [valorGlobalFiltro, setValorGlobalFiltro] = useState('');
    const [filtro, setFiltro] = useState({global: {value: null, matchMode: FilterMatchMode.CONTAINS}});

    const carregarCombos = async () => {
        await new api().requisitar('get', `/cadastro/categoria/combo`).then((resposta) => {
            setListaCategoria(resposta ?? []);
        }).catch((erro) => {
            debug(erro);
        });

        await new api().requisitar('get', `/cadastro/cliente/combo`).then((resposta) => {
            setListaClientes(resposta ?? []);
        }).catch((erro) => {
            debug(erro);
        });
    }

    const carregarItens = async () => {
        setLoading(true);
        await new api().requisitar('get', endpointAPI).then((resposta) => {
            setLista(resposta);
            setIdEvento(resposta?.length ?? 0);
            setLoading(false);
        }).catch((erro) => {
            debug(erro);
        });
    };

    const limparTela = () => {
        setItem(inicial);
    };

    const excluir = async (id) => {
        await new api().requisitar('DELETE', `${endpointAPI}/${id}`).then((resposta) => {
            aviso.current.show({severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000});
            limparTela();
            carregarItens();
        }).catch((erro) => {
            debug(erro);
            aviso.current.show({
                                   severity: 'error',
                                   summary : 'Erro',
                                   detail  : (erro.response && erro.response.data && erro.response.data.error_description) ? erro.response.data.error_description : 'Ocorreu um erro não tratado',
                                   life    : 3000
                               });
        });
    };

    const excluirParticipante = async (idparticipante, idevento) => {
        await new api().requisitar('DELETE', `cadastro/participante/${idparticipante}`).then(async (resposta) => {
            aviso.current.show({severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000});
            await new api().requisitar('get', `cadastro/evento/participacoes/${idevento}`).then((resposta) => {
                setParticipantes(resposta);
            }).catch((erro) => {
                debug(erro);
            });
        }).catch((erro) => {
            debug(erro);
            aviso.current.show({
                                   severity: 'error',
                                   summary : 'Erro',
                                   detail  : (erro.response && erro.response.data && erro.response.data.error_description) ? erro.response.data.error_description : 'Ocorreu um erro não tratado',
                                   life    : 3000
                               });
        });
    };

    const aoSelecionar = (evt) => {
        if (evt) {
            let tmp = {...evt};
            tmp.data = moment(evt.data, 'DD/MM/YYYY HH:mm:ss').toDate();
            tmp.dia = moment(tmp.data).format('DD/MM/YYYY');
            tmp.hora = moment(tmp.data).format('HH:mm');
            if (evt.datafim) {
                tmp.datafim = moment(evt.datafim, 'DD/MM/YYYY HH:mm:ss').toDate();
                tmp.diaf = moment(tmp.datafim).format('DD/MM/YYYY');
                tmp.horaf = moment(tmp.datafim).format('HH:mm');
            }
            setItem(tmp);
            setTabAtiva(0);
        }
    }

    const aoMudarFiltroGlobal = (e) => {
        const value = e.target.value;
        let _filtro = {...filtro};
        _filtro['global'].value = value;

        setFiltro(_filtro);
        setValorGlobalFiltro(value);
    }

    useEffect(() => {
        carregarCombos();
        carregarItens();
    }, []);

    const aoExcluirItem = (id) => {
        confirmDialog({
                          message    : `Confirma exclusão do Evento?`,
                          header     : 'Atenção',
                          icon       : 'pi pi-exclamation-triangle',
                          acceptLabel: 'Sim',
                          rejectLabel: 'Não',
                          accept     : () => {
                              excluir(id);
                          },
                      });
    };

    const aoSalvar = async () => {
        try {
            if (UsuarioMaster() && !item.idcliente) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Selecione o cliente!'};
            }
            if (!item.titulo) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe o nome do evento!'};
            }
            if (!item.local) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe o local!'};
            }
            if (!item.dia) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe a data!'};
            }
            if (!item.hora) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe a hora!'};
            }

            if (!moment(`${item.dia}`, 'DD/MM/YYYY').isValid()) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Data de início inválida!'};
            }

            if (!moment(`${item.dia} ${item.hora}`, 'DD/MM/YYYY HH:mm').isValid()) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Hora de início inválida!'};
            }

            item.data = moment(`${item.dia} ${item.hora}`, 'DD/MM/YYYY HH:mm');

            if (!moment(`${item.diaf}`, 'DD/MM/YYYY').isValid()) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Data de término inválida!'};
            }

            if (!moment(`${item.diaf} ${item.horaf}`, 'DD/MM/YYYY HH:mm').isValid()) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Hora de término inválida!'};
            }

            item.datafim = moment(`${item.diaf} ${item.horaf}`, 'DD/MM/YYYY HH:mm');

            item.telefone = parseInt(item.telefone);
            item.empresa = parseInt(item.empresa);
            item.crm = parseInt(item.crm);
            item.cargo = parseInt(item.cargo);
            item.especialidade = parseInt(item.especialidade);
            item.rg = parseInt(item.rg);
            item.cpf = parseInt(item.cpf);
            item.nascimento = parseInt(item.nascimento);
            item.cep = parseInt(item.cep);
            item.estado = parseInt(item.estado);
            item.cidade = parseInt(item.cidade);
            item.enderecop = parseInt(item.enderecop);

            await new api().requisitar((item.id > 0) ? 'put' : 'post', (item.id > 0 ? `${endpointAPI}/${item.id ?? ''}` : endpointAPI), item).then((resposta) => {
                aviso.current.show({severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000});
                limparTela();
                carregarItens();
            }).catch((erro) => {
                throw {tipo: 'error', titulo: 'Falha!!', mensagem: erro.response.data ?? 'Ocorreu um erro não tratado'};
            });

        } catch (erro) {
            aviso.current.show({severity: erro.tipo ?? 'error', summary: erro.titulo ?? 'Erro', detail: erro.mensagem ?? erro, life: 3000});
        }
    };
    const aoDigitar = (e, propriedade) => {
        let texto;
        const checks = ['nome', 'email', 'telefone', 'empresa', 'crm', 'cargo', 'especialidade', 'rg', 'cpf', 'nascimento', 'cep', 'estado', 'cidade', 'enderecop'];
        if (checks.includes(propriedade)) {
            texto = e.value ? 1 : 0;
        } else {
            if (propriedade === 'tipo') {
                texto = e.value;
            } else {
                texto = (e.target && e.target.value) || '';
            }
        }
        let _item = {...item};
        _item[`${propriedade}`] = texto;
        setItem(_item);
    };

    const aoCarregarParticipantes = async (evento) => {
        await new api().requisitar('get', `cadastro/evento/participacoes/${evento.id}`).then((resposta) => {
            setItem(evento);
            setParticipantes(resposta);
            setTituloParticipantes(evento.titulo);
            setIdEvento(evento.id);
            setExibirTela(true);
        }).catch((erro) => {
            debug(erro);
        });
    }

    const btnQrCode = (evento) => {
        return (
            <div>
                <a href={`${URLAPI}/${endpointAPI}/qrcode/${evento.hash}`} title={"Visualizar QR Code"} target={"_blank"} className={"mr-1"}>
                    <Button icon={"pi pi-qrcode"} severity="info" style={{backgroundColor: "black"}}/>
                </a>

                <a href={`${URLAPI}/${endpointAPI}/download?evento=${encodeURI(evento.titulo)}&link=${URLAPI}/${endpointAPI}/qrcode/${evento.hash}`} download={`${evento.titulo}-QRCOde.png`} title={"Fazer download do arquivo"} target={"_blank"}>
                    <Button icon={"pi pi-download"} severity="info" style={{backgroundColor: "black"}}/>
                </a>
            </div>
        );
    }

    const btnParticipantes = (evento) => {
        if (evento.participantes) {
            return (
                <div>
                    <a href={`${URLAPI}/${endpointAPI}/participantes/${evento.id}`} title={"Download da lista de participantes XLS"} target={"_blank"} className={"mr-1"}>
                        <Button icon={"pi pi-file-excel"} severity="info"/>
                    </a>
                    <a href={`${URLAPI}/${endpointAPI}/participantespdf/${evento.id}`} title={"Download da lista de participantes PDF"} target={"_blank"} className={"mr-1"}>
                        <Button icon={"pi pi-file-pdf"} severity="info"/>
                    </a>
                    <Button icon={"pi pi-eye"} severity="info" onClick={(e) => aoCarregarParticipantes(evento)}/>
                </div>
            );
        } else {
            return (<div>Sem participantes</div>);
        }
    }

    const btnEditar = (item) => {
        return (
            <Button icon={"pi pi-pencil"} severity="warning" onClick={(e) => aoSelecionar(item)}/>
        );
    }

    const cabecalhoTabela = (<React.Fragment>
        <CabecalhoTabela className='hidden md:flex'>
            <span className="m-0 text-lg">Eventos já cadastrados</span>
            <span className="p-input-icon-left">
                <i className="pi pi-search"/>
                <InputText value={valorGlobalFiltro} onChange={aoMudarFiltroGlobal} placeholder="Pesquise aqui"/>
            </span>
        </CabecalhoTabela>
        <div className='block md:hidden'>
            <div className='grid'>
                <div className="col-12">Eventos já cadastrados</div>
                <div className="col-12 p-input-icon-left">
                    <i className="pi pi-search"/>
                    <InputText value={valorGlobalFiltro} onChange={aoMudarFiltroGlobal} placeholder="Pesquise aqui"/>
                </div>
            </div>
        </div>
    </React.Fragment>);

    const botoesAcaoTela = () => {
        return (
            <div>
                <a href={`${URLAPI}/${endpointAPI}/participantes/${idEvento}`} title={"Download da lista de participantes XLS"} target={"_blank"} className={"mr-1"}>
                    <Button label='Excel' icon={"pi pi-file-excel"} className="p-button-text"/>
                </a>
                <a href={`${URLAPI}/${endpointAPI}/participantespdf/${idEvento}`} title={"Download da lista de participantes PDF"} target={"_blank"} className={"mr-1"}>
                    <Button label='PDF' icon={"pi pi-file-pdf"} className="p-button-text"/>
                </a>
                <Button label="Fechar" icon="pi pi-times" className="p-button-text" onClick={(e) => setExibirTela(false)}/>
            </div>);
    };

    const aoExcluirParticipante = (idparticipante, idevento) => {
        confirmDialog({
                          message    : `Confirma exclusão do Participante?`,
                          header     : 'Atenção',
                          icon       : 'pi pi-exclamation-triangle',
                          acceptLabel: 'Sim',
                          rejectLabel: 'Não',
                          accept     : () => {
                              excluirParticipante(idparticipante, idevento);
                          },
                      });
    };

    const tplParticipante = (participante) => {
        return (
            <div className='col-12 md:col-4 p-2'>
                <Card>
                    <div className="mb-2">
                        <i className="pi pi-user mr-2" style={{fontSize: '1rem', backgroundColor: "#4547a9", color: "#fff", padding: 10, borderRadius: 3}}></i>{participante.nome}
                    </div>
                    <div className="mb-2">
                        <i className="pi pi-envelope mr-2" style={{fontSize: '1rem', backgroundColor: "#4547a9", color: "#fff", padding: 10, borderRadius: 3}}></i>{participante.email}
                    </div>
                    {item?.crm == 1 &&
                     <div className="mb-2">
                         <i className="pi pi-id-card mr-2" style={{fontSize: '1rem', backgroundColor: "#4547a9", color: "#fff", padding: 10, borderRadius: 3}}></i>{participante.crm}
                     </div>
                    }
                    {item?.cargo == 1 &&
                     <div className="mb-2">
                         <i className="pi pi-id-card mr-2" style={{fontSize: '1rem', backgroundColor: "#4547a9", color: "#fff", padding: 10, borderRadius: 3}}></i>{participante.cargo}
                     </div>
                    }
                    {item?.especialidade == 1 &&
                     <div className="mb-2">
                         <i className="pi pi-user-plus mr-2" style={{fontSize: '1rem', backgroundColor: "#4547a9", color: "#fff", padding: 10, borderRadius: 3}}></i>{participante.especialidade}
                     </div>
                    }
                    {item?.rg == 1 &&
                     <div className="mb-2">
                         <i className="pi pi-tablet mr-2" style={{fontSize: '1rem', backgroundColor: "#4547a9", color: "#fff", padding: 10, borderRadius: 3}}></i>{participante.rg}
                     </div>
                    }
                    {item?.cpf == 1 &&
                     <div className="mb-2">
                         <i className="pi pi-wallet mr-2" style={{fontSize: '1rem', backgroundColor: "#4547a9", color: "#fff", padding: 10, borderRadius: 3}}></i>{participante.cpf}
                     </div>
                    }
                    {item?.nascimento == 1 &&
                     <div className="mb-2">
                         <i className="pi pi-calendar-plus mr-2" style={{fontSize: '1rem', backgroundColor: "#4547a9", color: "#fff", padding: 10, borderRadius: 3}}></i>{participante.nascimento}
                     </div>
                    }
                    {item?.cep == 1 &&
                     <div className="mb-2">
                         <i className="pi pi-map mr-2" style={{fontSize: '1rem', backgroundColor: "#4547a9", color: "#fff", padding: 10, borderRadius: 3}}></i>{participante.cep}
                     </div>
                    }
                    {item?.estado == 1 &&
                     <div className="mb-2">
                         <i className="pi pi-map mr-2" style={{fontSize: '1rem', backgroundColor: "#4547a9", color: "#fff", padding: 10, borderRadius: 3}}></i>{participante.estado}
                     </div>
                    }
                    {item?.cidade == 1 &&
                     <div className="mb-2">
                         <i className="pi pi-map mr-2" style={{fontSize: '1rem', backgroundColor: "#4547a9", color: "#fff", padding: 10, borderRadius: 3}}></i>{participante.cidade}
                     </div>
                    }
                    {item?.enderecop == 1 &&
                     <div className="mb-2">
                         <i className="pi pi-home mr-2" style={{fontSize: '1rem', backgroundColor: "#4547a9", color: "#fff", padding: 10, borderRadius: 3}}></i>{participante.enderecop}
                     </div>
                    }
                    <div className="mb-2">
                        <i className="pi pi-calendar mr-2" style={{fontSize: '1rem', backgroundColor: "#4547a9", color: "#fff", padding: 10, borderRadius: 3}}></i>{participante.registro}
                    </div>
                    <div className="mb-2 text-center">
                        <Button label='Excluir' icon={"pi pi-trash"} severity="danger" onClick={(e) => aoExcluirParticipante(participante.idparticipante, participante.idevento)}/>
                    </div>
                </Card>
            </div>
        );
    }

    return (
        <FundoSistema>
            <Menu/>
            <Toast ref={aviso}></Toast>
            <TelaSistema title="Cadastro de Evento">
                <TabView activeIndex={tabAtiva} onTabChange={(e) => setTabAtiva(e.index)}>
                    <TabPanel header='Cadastro' leftIcon={(ico) => <Icone className="mr-2" src={iconeEvento}/>}>
                        <div className="grid formgrid">
                            {UsuarioMaster() &&
                             <div className="field col-12 md:col-6">
                                 <label htmlFor="idcliente">Cliente<Obrigatorio>*</Obrigatorio> </label><br/>
                                 <Dropdown className="w-full" autoComplete="none" id="idcliente" value={item?.idcliente} options={listaClientes} onChange={(e) => aoDigitar(e, 'idcliente')} optionLabel="valor" optionValue="id" required/>
                             </div>
                            }
                            <div className="field col-12 md:col-6">
                                <label htmlFor="idcategoria">Categoria</label><br/>
                                <Dropdown className="w-full" autoComplete="none" id="idcategoria" value={item?.idcategoria} options={listaCategoria} onChange={(e) => aoDigitar(e, 'idcategoria')} optionLabel="valor" optionValue="id" required/>
                            </div>
                            <div className="field col-12 md:col-6 mt-3">
                                <label htmlFor="responsavel">Responsável</label><br/>
                                <InputText className="w-full" autoComplete="none" id="responsavel" maxLength={255} value={item.responsavel} onChange={(e) => aoDigitar(e, 'responsavel')} required/>
                            </div>
                            <div className="field col-12 md:col-3 mt-3">
                                <label htmlFor="dia">Data início<Obrigatorio>*</Obrigatorio></label><br/>
                                <InputMask id="dia" mask="99/99/9999" placeholder="dd/mm/yyyy" value={item.dia} onChange={(e) => aoDigitar(e, 'dia')}/>
                            </div>
                            <div className="field col-3 md:col-3 mt-3">
                                <label htmlFor="hora">Hora início<Obrigatorio>*</Obrigatorio></label><br/>
                                <InputMask id="hora" mask="99:99" placeholder="HH:mm" value={item.hora} onChange={(e) => aoDigitar(e, 'hora')}/>
                            </div>
                            <div className="field col-12 md:col-3 mt-3">
                                <label htmlFor="diaf">Data término</label><br/>
                                <InputMask id="diaf" mask="99/99/9999" placeholder="dd/mm/yyyy" value={item.diaf} onChange={(e) => aoDigitar(e, 'diaf')}/>
                            </div>
                            <div className="field col-3 md:col-3 mt-3">
                                <label htmlFor="horaf">Hora término</label><br/>
                                <InputMask id="horaf" mask="99:99" placeholder="HH:mm" value={item.horaf} onChange={(e) => aoDigitar(e, 'horaf')}/>
                            </div>

                            <div className="field col-12 flex flex-row flex-wrap">
                                <div className="flex-initial w-8rem mt-2">
                                    <RadioButton inputId="eventoE" name="tipo" value="E" onChange={(e) => aoDigitar(e, 'tipo')} checked={item.tipo != 'O'}/>
                                    <label htmlFor="eventoE" className="ml-2">Evento</label>
                                </div>
                                <div className="flex-initial w-8rem mt-2">
                                    <RadioButton inputId="eventoO" name="tipo" value="O" onChange={(e) => aoDigitar(e, 'tipo')} checked={item.tipo == 'O'}/>
                                    <label htmlFor="eventoO" className="ml-2">Outros</label>
                                </div>
                            </div>
                            {item.tipo === 'O' &&
                             <div className="field col-12 mt-1">
                                 <label htmlFor="frase">Frase confirmação presença</label><br/>
                                 <InputText className="w-full" autoComplete="none" id="frase" maxLength={255} value={item.frase} onChange={(e) => aoDigitar(e, 'frase')} required/>
                             </div>
                            }

                            <div className="field col-12">
                                <label htmlFor="titulo">Título (nome do evento)<Obrigatorio>*</Obrigatorio></label><br/>
                                <InputText className="w-full" autoComplete="none" id="titulo" maxLength={255} value={item.titulo} onChange={(e) => aoDigitar(e, 'titulo')} required/>
                            </div>

                            <Panel header="Campos solicitados na lista de presença" className="w-full">
                                <div className="field col-12 flex flex-row flex-wrap">
                                    <div className="flex-initial w-8rem mt-2">
                                        <label htmlFor="nome">Nome</label><br/>
                                        <InputSwitch inputId="nome" checked={item.nome == 1} onChange={(e) => aoDigitar(e, 'nome')}/>
                                    </div>
                                    <div className="flex-initial w-8rem mt-2">
                                        <label htmlFor="email">E-mail</label><br/>
                                        <InputSwitch inputId="email" checked={item.email == 1} onChange={(e) => aoDigitar(e, 'email')}/>
                                    </div>
                                    <div className="flex-initial w-8rem mt-2">
                                        <label htmlFor="telefone">Telefone</label><br/>
                                        <InputSwitch inputId="telefone" checked={item.telefone == 1} onChange={(e) => aoDigitar(e, 'telefone')}/>
                                    </div>
                                    <div className="flex-initial w-8rem mt-2">
                                        <label htmlFor="empresa">Empresa</label><br/>
                                        <InputSwitch inputId="empresa" checked={item.empresa == 1} onChange={(e) => aoDigitar(e, 'empresa')}/>
                                    </div>
                                    <div className="flex-initial w-8rem mt-2">
                                        <label htmlFor="crm">CRM</label><br/>
                                        <InputSwitch inputId="crm" checked={item.crm == 1} onChange={(e) => aoDigitar(e, 'crm')}/>
                                    </div>
                                    <div className="flex-initial w-8rem mt-2">
                                        <label htmlFor="crm">Cargo</label><br/>
                                        <InputSwitch inputId="crm" checked={item.cargo == 1} onChange={(e) => aoDigitar(e, 'cargo')}/>
                                    </div>
                                    <div className="flex-initial w-8rem mt-2">
                                        <label htmlFor="especialidade">Especialidade</label><br/>
                                        <InputSwitch inputId="especialidade" checked={item.especialidade == 1} onChange={(e) => aoDigitar(e, 'especialidade')}/>
                                    </div>
                                    <div className="flex-initial w-8rem mt-2">
                                        <label htmlFor="rg">RG</label><br/>
                                        <InputSwitch inputId="rg" checked={item.rg == 1} onChange={(e) => aoDigitar(e, 'rg')}/>
                                    </div>
                                    <div className="flex-initial w-8rem mt-2">
                                        <label htmlFor="cpf">CPF</label><br/>
                                        <InputSwitch inputId="cpf" checked={item.cpf == 1} onChange={(e) => aoDigitar(e, 'cpf')}/>
                                    </div>
                                    <div className="flex-initial w-8rem mt-2">
                                        <label htmlFor="nascimento">Nascimento</label><br/>
                                        <InputSwitch inputId="nascimento" checked={item.nascimento == 1} onChange={(e) => aoDigitar(e, 'nascimento')}/>
                                    </div>
                                    <div className="flex-initial w-8rem mt-2">
                                        <label htmlFor="cep">CEP</label><br/>
                                        <InputSwitch inputId="cep" checked={item.cep == 1} onChange={(e) => aoDigitar(e, 'cep')}/>
                                    </div>
                                    <div className="flex-initial w-8rem mt-2">
                                        <label htmlFor="estado">Estado</label><br/>
                                        <InputSwitch inputId="estado" checked={item.estado == 1} onChange={(e) => aoDigitar(e, 'estado')}/>
                                    </div>
                                    <div className="flex-initial w-8rem mt-2">
                                        <label htmlFor="cidade">Cidade</label><br/>
                                        <InputSwitch inputId="cidade" checked={item.cidade == 1} onChange={(e) => aoDigitar(e, 'cidade')}/>
                                    </div>
                                    <div className="flex-initial w-8rem mt-2">
                                        <label htmlFor="enderecop">Endereço</label><br/>
                                        <InputSwitch inputId="enderecop" checked={item.enderecop == 1} onChange={(e) => aoDigitar(e, 'enderecop')}/>
                                    </div>
                                </div>
                            </Panel>

                            <div className="field col-12 mt-1">
                                <label htmlFor="descricao">Descrição</label><br/>
                                <InputTextarea rows={5} className="w-full" autoComplete="none" id="descricao" value={item.descricao} onChange={(e) => aoDigitar(e, 'descricao')} autoResize required/>
                            </div>
                            <div className="field col-12">
                                <label htmlFor="local">Local<Obrigatorio>*</Obrigatorio> </label><br/>
                                <InputText className="w-full" autoComplete="none" id="local" maxLength={255} value={item.local} onChange={(e) => aoDigitar(e, 'local')} required/>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Imagem do evento</label><br/>
                                <EnviarImagem imagem={item.imagem} setImagem={(e) => {
                                    setItem({...item, imagem: e})
                                }} urlUpload={endpointAPI + '/upload'} aviso={aviso} pasta={'imagens'}/>
                            </div>
                            <div className="field col-12 md:col-6" style={{textAlign: 'center'}}>
                                <Image src={`${URLAPI}/${endpointAPI}/qrcode/${item.hash}`} width={300}/><br/>
                                <a href={`${URLAPI}/${endpointAPI}/download?evento=${encodeURI(item.titulo)}&link=${URLAPI}/${endpointAPI}/qrcode/${item.hash}`} download={`${item.titulo}-QRCOde.png`} target={"_blank"}>
                                    <Button label={"Download arquivo QRCode"} severity="secondary" className="mt-2"/>
                                </a>
                            </div>

                            <div className="field col-12 md:col-6">
                                <span className="hidden md:block">
                                    <label htmlFor="nome">&nbsp;</label><br/>
                                </span>
                                <Button label="Salvar" severity='success' icon="pi pi-check" className="p-button-text mr-2" raised onClick={aoSalvar}/>
                                {item.id > 0 && <React.Fragment>
                                    <Button label="Excluir" severity='danger' icon="pi pi-trash" className="p-button-text mr-2" raised onClick={(e) => aoExcluirItem(item.id)}/>
                                    <Button label="Cancelar" severity='help' icon="pi pi-undo" className="p-button-text" raised onClick={(e) => setItem(inicial)}/>
                                </React.Fragment>}
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header='Meus Eventos' leftIcon={(ico) => <Icone className="mr-2" src={iconeLista}/>}>
                        <DataTable removableSort stripedRows
                                   value={lista} responsiveLayout='stack' globalFilterFields={['nome']} selectionMode='single'
                                   selection={item} loading={loading}
                                   globalFilter={pesquisaGeral} filters={filtro} header={cabecalhoTabela}
                                   emptyMessage='Nenhum cliente cadastrado'>
                            {UsuarioMaster() &&
                             <Column field={'cliente'} header={'Cliente'} sortable/>
                            }
                            <Column field={'titulo'} header={'Título'} sortable/>
                            <Column field={'local'} header={'Local'} sortable/>
                            <Column field={'data'} header={'Data'} sortable/>
                            <Column field={'hash'} header={'QR Code'} body={btnQrCode}/>
                            <Column field={'id'} header={'Participantes'} body={btnParticipantes}/>
                            <Column field={'id'} header={''} body={btnEditar}/>
                        </DataTable>
                    </TabPanel>

                </TabView>
            </TelaSistema>

            <Dialog className='fluid' header={tituloParticipantes} style={{width: '99%'}} footer={botoesAcaoTela} modal={true} visible={exibeTela} onHide={(e) => setExibirTela(false)}>
                <Image src={iconeParticipantes} title={'Participantes'} alt={'Participantes'} style={{width: 150, margin: 'auto', display: 'block'}} imageStyle={{width: 150, margin: 'auto', display: 'block'}}/><br/>
                <div className="text-center"><h2>Lista de participantes</h2></div>
                <DataView layout={'grid'} value={participantes} itemTemplate={tplParticipante} emptyMessage={'Nenhum participante para este evento'}/>
            </Dialog>
        </FundoSistema>
    );
}

export default Evento;